import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap-5';

import Button from 'shared/button';
import Modal from 'components/modal';

class FormModal extends React.Component {
  static propTypes = {
    asSidebar: PropTypes.bool,
    backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    footerContent: PropTypes.node,
    header: PropTypes.string.isRequired,
    hideSubmit: PropTypes.bool,
    renderErrorsInFooter: PropTypes.bool,
    saveButtonClassName: PropTypes.string,
    saveButtonLabel: PropTypes.string,
    show: PropTypes.bool,
    size: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onError: PropTypes.func,
    onShow: PropTypes.func,

    // Should return a promise that is rejected with an array of error strings
    // TODO: Need to standardize error responses into something mappable to inputs
    onSubmit: PropTypes.func.isRequired,

    onSuccess: PropTypes.func
  }

  static defaultProps = {
    backdrop: 'static',
    saveButtonLabel: 'Save',
    onError: () => {},
    onShow: () => {},
    onSuccess: () => {}
  }

  state = {
    errors: []
  }

  componentDidUpdate(previousProps) {
    if (!previousProps.show && this.props.show) {
      this.setState({ errors: [], saving: false });
    }
  }

  save = () => {
    this.setState({ errors: [], saving: true });

    this.props.onSubmit()
      .then((response) => {
        this.setState({ saving: false });
        this.props.onSuccess(response);
      })
      .catch((errors) => {
        this.setState({ errors, saving: false });
        this.props.onError(errors);
      });
  }

  render() {
    const {
      asSidebar,
      children,
      header,
      renderErrorsInFooter,
      saveButtonClassName,
      saveButtonLabel,
      onCancel,
      onSuccess,
      ...props
    } = this.props;

    props.className = props.className || '';
    if (asSidebar) {
      props.className += ' modal--sidebar';
    }

    return (
      <Modal {...props} onHide={onCancel}>
        <Modal.Header closeButton>
          {header}
        </Modal.Header>

        <Modal.Body>
          {this.renderBodyErrors()}
          {children}
        </Modal.Body>

        <Modal.Footer>
          <div className="me-auto">
            {this.props.footerContent}
            {this.renderFooterErrors()}
          </div>
          {this.renderControls()}
        </Modal.Footer>
      </Modal>
    );
  }

  renderControls() {
    return <>
      <Button.Cancel onClick={this.props.onCancel}/>
      {!this.props.hideSubmit && (
        <Button.Primary
          aria-label="save"
          className={this.props.saveButtonClassName}
          disabled={this.state.saving || this.props.disabled}
          label={this.props.saveButtonLabel}
          onClick={this.save}
        />
      )}
    </>;
  }

  renderBodyErrors() {
    if (this.props.renderErrorsInFooter) {
      return;
    }

    const { errors } = this.state;

    if (errors && errors.length > 0) {
      return (
        <Alert className="mb-2" name="errors" variant="warning">
          {errors.map((error, i) => <div key={i}>{error}</div>)}
        </Alert>
      );
    }
  }

  renderFooterErrors() {
    if (!this.props.renderErrorsInFooter) {
      return;
    }

    if (this.state.errors.length === 1) {
      return (
        <div className="me-4 text-danger">
          {this.state.errors}
        </div>
      );
    } else {
      return (
        <div className="me-4 text-danger">
          <ul>
            {this.state.errors.map((error, index) => (
              <li key={index}>
                {error}
              </li>
            ))}
          </ul>
        </div>
      );
    }
  }
}

export default FormModal;
